import { render, staticRenderFns } from "./AdvProductPageCard.vue?vue&type=template&id=072680e6&scoped=true"
import script from "./AdvProductPageCard.vue?vue&type=script&lang=js"
export * from "./AdvProductPageCard.vue?vue&type=script&lang=js"
import style0 from "./AdvProductPageCard.vue?vue&type=style&index=0&id=072680e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072680e6",
  null
  
)

export default component.exports